"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

if (typeof document !== 'undefined') {
  _reactModal["default"].setAppElement(document.body);
}

var ReactModalAdapter = function ReactModalAdapter(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeTimeoutMS = _ref.closeTimeoutMS,
      contentLabel = _ref.contentLabel,
      height = _ref.height,
      hasVariableHeight = _ref.hasVariableHeight,
      isOpen = _ref.isOpen,
      modalClassName = _ref.modalClassName,
      onRequestClose = _ref.onRequestClose,
      overlayClassName = _ref.overlayClassName,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    bodyOpenClassName: "portalOpen",
    className: modalClassName,
    closeTimeoutMS: closeTimeoutMS,
    contentLabel: contentLabel,
    height: height,
    hasVariableHeight: hasVariableHeight,
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    overlayClassName: overlayClassName,
    portalClassName: className,
    theme: theme
  }, children);
};

ReactModalAdapter.defaultProps = {
  children: undefined,
  closeTimeoutMS: 500,
  contentLabel: undefined,
  height: 400,
  hasVariableHeight: false,
  isOpen: false,
  onRequestClose: undefined,
  overlayClassName: undefined,
  theme: {}
};
ReactModalAdapter.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string.isRequired,
  closeTimeoutMS: _propTypes.number,
  contentLabel: _propTypes.string,
  height: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  hasVariableHeight: _propTypes.bool,
  isOpen: _propTypes.bool,
  modalClassName: _propTypes.string.isRequired,
  onRequestClose: _propTypes.func,
  overlayClassName: _propTypes.string,
  theme: (0, _propTypes.shape)({})
};
ReactModalAdapter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ReactModalAdapter",
  "props": {
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "closeTimeoutMS": {
      "defaultValue": {
        "value": "500",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "contentLabel": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "400",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "hasVariableHeight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onRequestClose": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "overlayClassName": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "modalClassName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = ReactModalAdapter;
exports["default"] = _default;